import dynamic from 'next/dynamic';
export const NavItemRender = dynamic(() => import('./Testimonials'));
export { default } from './Testimonials';
